import { ReservationLog } from '@shared/services/api/reservation-logger-data.service';

//export const GUEST_TYPES = ['Guest', 'Operator'];
export enum GUEST_TYPES {
	guest = 0,
	primaryOperator = 1,
	operator = 2,
	additionalOperator = 3,
}
export const GUEST_TYPES_MAP = {
	0: 'passenger',
	1: 'operator',
	2: 'operator',
	3: 'additional_operator',
};

export enum INSURANCE_COVERAGE_TYPES {
	NONE = 0,
	BASIC = 1,
	STANDARD = 2,
	COMPREHENSIVE = 3,
}
export const INSURANCE_COVERAGE_TYPES_MAP = {
	0: 'none',
	1: 'basic',
	2: 'standard',
	3: 'comprehensive',
};

export const MANIFEST_HOME = '/public/manifests/product-list';

export const EVENT_MANIFEST_LOADER_ON = 'MANiFEST:LOADER_ON';
export const EVENT_MANIFEST_BUTTON_RESET = 'BUTTON:RESET';
export const LOGGER_PARAMS: ReservationLog = {
	logType: 'Manifest',
	authority: 'Company',
};

export const MANIFEST_LOG = {
	ProductListPage: {
		pageSetup: 'Viewing product list',
		confirmManifests: 'Confirmed manifest',
		onBack: 'Exiting manifests',
		productChange: 'Changing active product',
		lockAllProducts: 'Locking all products',
		doRefresh: 'Refreshing products list',
		onForward: 'Navigate to product insurance page',
		setActiveProduct: 'Setting active product',
	},
	ProductInsuranceListPage: {
		pageSetup: 'Viewing product insurance list',
		purchaseInsurance: 'Purchasing product insurance',
		back: 'Navigating back to product list',
		completeManifests: 'Completing the manifest',
	},
	ProductInsurancePage: {
		pageSetup: 'Viewing product insurance',
		onInsuranceComplete: 'Completed insurance process',
		back: 'Navigating back to product insurance list',
	},
	MinorsPage: {
		pageSetup: 'Viewing minors form',
		next: 'Finished adding minors',
		cancel: 'Navigating back to guest form',
	},
	GuidedGuestConfirmPage: {
		ionViewWillEnter: 'Viewing guest confirmation page',
		sendRegistrationLink: 'Copied reservation link to clipboard',
	},
	GuestProductListPage: {
		pageSetup: 'Viewing guest product list',
		navigateToProduct: 'Navigating to a product',
	},
	GuestProductPage: {
		pageSetup: 'Viewing manifest product',
	},
	GuestIdentificationPage: {
		pageSetup: 'Viewing identification upload page',
		next: 'Navigating to manifest guest confiramation',
		selectImage: 'Selecting an ID image from phone photos',
		onFileChange: 'Successfully picked an image from phone photos',
		removeFile: 'Removed uploaded image',
		handleError: 'There was an error uploading the image',
		back: 'Navigating back to guest documents',
	},
	GuestFormPage: {
		pageSetup: 'Viewing guest form',
		prefillFormFields: 'Prefilling all saved guest fields',
		setVettingQuestions: 'Setting up vetting questions',
		onDateChange: 'Changed date of birth',
		submitForm: '',
		save: 'Saving guest form',
		submitVettingQuestions: 'Submitting vetting question answers',
		cancel: 'Navigating back to product list',
		initializeScanner: 'Using ID scanner',
		processNextSteps: 'Navigating to guest documents',
		setupForm: 'Setting up all form fields for guest form',
		setRequiredFields: 'Setting required fields for guest form',
		requiredFieldsActions: 'Setting required fields for guest form',
		setDOBValue: 'Setting data of birth value',
	},
	GuestDocumentsPage: {
		pageSetup: 'Viewing guest documents',
		onGuestUpdate: 'Guest has completed their documents and/or signature',
		processNextStep: 'Guest has completed and signed their documents',
	},
	GuestCheckedinPage: {
		pageSetup: 'Viewing guest completion page',
		complete: 'Guest has confirmed their completed manifest',
		back: 'Navigating back to guest identification',
	},
	MultiProductInsurancePage: {
		pageSetup: 'Viewing multi product insurance page',
		productSetup: 'Setting up product for policy generation',
		onInsuranceComplete: 'Completed insurance process',
		updateProduct: 'Updating the product after policies generated',
		lockProduct: 'Locking the product before generating the policies',
		back: 'Navigating back to product insurance list',
	},
};
